// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosInstance";
// import toast from "react-hot-toast";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import { Pagination, Autoplay } from "swiper/modules";
// import dayjs from "dayjs";
// import { useNavigate } from "react-router-dom";
// import ProfileCompletionModal from "./ProfileCompletionModal";
// import bg from "../../assets/membership.jpg";

// const SkeletonCard = () => (
//   <div className="flex flex-col items-center bg-gray-100 animate-pulse p-6 rounded-xl shadow w-full h-72 justify-center">
//     <div className="w-28 h-28 md:w-32 md:h-32 bg-gray-300 rounded-full mb-4"></div>
//     <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
//     <div className="h-3 bg-gray-300 rounded w-16"></div>
//   </div>
// );

// const MatchesCarousel = () => {
//   const [matches, setMatches] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const [showCompletionModal, setShowCompletionModal] = useState(false);
//   const [completionPercentage, setCompletionPercentage] = useState(0);

//   const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

//   useEffect(() => {
//     const fetchMatches = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get("/api/matches/", {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         });
//         setMatches(res.data);

//         const profileRes = await axios.get("/api/matrimony-profile/update/", {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         });

//         const percent = profileRes.data.profile_completion_percentage;
//         setCompletionPercentage(percent);

//         if (percent < 90 && !localStorage.getItem("profileModalShown")) {
//           setShowCompletionModal(true);
//           localStorage.setItem("profileModalShown", "true");
//         }

//         setLoading(false);
//       } catch (error) {
//         toast.error("Failed to load matches");
//         setLoading(false);
//       }
//     };

//     fetchMatches();
//   }, []);

//   return (
//     <div className="w-full p-6 bg-white rounded-2xl shadow-lg border border-gray-100">
//       {/* Profile Completion Modal */}
//       <ProfileCompletionModal
//         isOpen={showCompletionModal}
//         onClose={() => setShowCompletionModal(false)}
//         percentage={completionPercentage}
//       />

//       {/* Section Header */}
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
//         <div>
//           <h2 className="text-2xl font-bold text-gray-800">
//             All Matches{" "}
//             <span className="text-pink-600">({matches.length})</span>
//           </h2>
//           <p className="text-gray-500 text-sm">
//             Members who closely match your partner preferences
//           </p>
//         </div>
//         <button
//           onClick={() => navigate("/matches-all--php-html-raj-put")}
//           className="mt-3 sm:mt-0 bg-pink-600 text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-pink-700 transition"
//         >
//           View All
//         </button>
//       </div>

//       {/* Matches Content */}
//       {loading ? (
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {[...Array(3)].map((_, idx) => (
//             <SkeletonCard key={idx} />
//           ))}
//         </div>
//       ) : matches.length > 0 ? (
//         <Swiper
//           slidesPerView={matches.length === 1 ? 1 : undefined}
//           spaceBetween={20}
//           autoplay={{ delay: 3500, disableOnInteraction: false }}
//           pagination={{ clickable: true }}
//           modules={[Pagination, Autoplay]}
//           breakpoints={
//             matches.length === 1
//               ? {}
//               : {
//                   640: { slidesPerView: Math.min(matches.length, 1) },
//                   768: { slidesPerView: Math.min(matches.length, 2) },
//                   1024: { slidesPerView: Math.min(matches.length, 3) },
//                 }
//           }
//           className="mySwiper [&_.swiper-pagination]:flex [&_.swiper-pagination]:justify-center [&_.swiper-pagination]:mt-5
//             [&_.swiper-pagination-bullet]:w-3 [&_.swiper-pagination-bullet]:h-3
//             [&_.swiper-pagination-bullet]:bg-gray-300 [&_.swiper-pagination-bullet]:opacity-100
//             [&_.swiper-pagination-bullet]:mx-1.5 [&_.swiper-pagination-bullet]:rounded-full
//             [&_.swiper-pagination-bullet-active]:bg-pink-600 [&_.swiper-pagination-bullet-active]:w-4 [&_.swiper-pagination-bullet-active]:h-4"
//         >
//           {matches.map((match) => (
//             <SwiperSlide key={match.id}>
//               <div
//                 onClick={() => navigate(`/profile/${match.user.id}`)}
//                 className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 flex flex-col items-center text-center cursor-pointer"
//                 style={{
//                   backgroundImage: `url(${bg})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                 }}
//               >
//                 {/* Profile Image */}
//                 <img
//                   src={
//                     match.photo || require("../../assets/default_image.webp")
//                   }
//                   alt={`${match.user.first_name}`}
//                   className="w-28 h-28 object-cover rounded-full border-4 border-pink-100 shadow mb-4"
//                 />

//                 {/* Name */}
//                 <p className="font-semibold text-lg text-gray-800">
//                   {`${match.user.first_name} ${match.user.last_name}`}
//                 </p>

//                 {/* Details */}
//                 <p className="text-sm text-gray-500 mt-1">
//                   {calculateAge(match.dob)} Yrs • {match.height_feet}’
//                   {match.height_inches}" height • {match.work_location_city}
//                 </p>

//                 {/* Action Button */}
//                 <button className="mt-4 bg-pink-600 text-white px-4 py-1.5 text-sm rounded-full hover:bg-pink-700 transition">
//                   View Profile
//                 </button>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       ) : (
//         <p className="text-gray-500 text-center py-6">No matches found.</p>
//       )}
//     </div>
//   );
// };

// export default MatchesCarousel;

// src/components/MatchesCarousel.jsx

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import ProfileCompletionModal from "./ProfileCompletionModal";

/* ─── CSS ─────────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jbmc {
  width: 100%;
  background: linear-gradient(160deg, #1A0505 0%, #3D0A0A 55%, #5A1010 100%);
  border: 1px solid rgba(201,150,42,0.25);
  border-radius: 20px;
  padding: clamp(20px, 3.5vw, 36px);
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow: hidden;
}

/* gold top bar */
.jbmc::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, transparent, #C9962A 30%, #E8C46A 50%, #C9962A 70%, transparent);
  z-index: 2;
}

/* dot-grid */
.jbmc-dust {
  position: absolute; inset: 0; pointer-events: none;
  background-image: radial-gradient(circle, rgba(201,150,42,0.08) 1px, transparent 1px);
  background-size: 36px 36px;
}

/* ── Header row ── */
.jbmc-header {
  position: relative; z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: clamp(16px, 2.5vw, 24px);
  flex-wrap: wrap;
}
.jbmc-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(18px, 2.4vw, 24px);
  font-weight: 700;
  color: #FDF6EC;
  margin-bottom: 4px;
  line-height: 1.2;
}
.jbmc-title em { font-style: italic; color: #E8C46A; }
.jbmc-count {
  font-family: 'Playfair Display', serif;
  font-size: clamp(13px, 1.4vw, 15px);
  color: #C9962A; font-weight: 600;
}
.jbmc-subtitle {
  font-size: clamp(11.5px, 1.2vw, 13px);
  color: rgba(253,246,236,0.6);
}
.jbmc-viewall {
  flex-shrink: 0;
  padding: 8px clamp(16px, 2vw, 22px);
  background: linear-gradient(90deg, #C9962A, #A87820);
  border: none; border-radius: 24px;
  color: #2C1A0E;
  font-size: clamp(12px, 1.2vw, 13.5px);
  font-weight: 700;
  font-family: 'Playfair Display', serif;
  cursor: pointer;
  transition: opacity 0.18s, transform 0.15s;
  white-space: nowrap;
  align-self: center;
}
.jbmc-viewall:hover { opacity: 0.88; transform: translateY(-1px); }

/* ── Skeleton ── */
.jbmc-skel {
  position: relative; z-index: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}
.jbmc-skel-card {
  background: rgba(201,150,42,0.07);
  border: 1px solid rgba(201,150,42,0.15);
  border-radius: 14px;
  padding: 24px 16px;
  display: flex; flex-direction: column; align-items: center;
  gap: 12px;
  animation: jbmcPulse 1.6s ease-in-out infinite;
}
@keyframes jbmcPulse {
  0%,100% { opacity: 1; }
  50%      { opacity: 0.45; }
}
.jbmc-skel-avatar {
  width: 88px; height: 88px; border-radius: 50%;
  background: rgba(201,150,42,0.15);
}
.jbmc-skel-line {
  height: 12px; border-radius: 6px;
  background: rgba(201,150,42,0.12);
}

/* ── Swiper overrides ── */
.jbmc-swiper {
  position: relative; z-index: 1;
  padding-bottom: 36px !important;
}
.jbmc-swiper .swiper-pagination { bottom: 0 !important; }
.jbmc-swiper .swiper-pagination-bullet {
  width: 8px; height: 8px;
  background: rgba(201,150,42,0.35) !important;
  opacity: 1 !important;
  margin: 0 4px !important;
  border-radius: 50%;
  transition: all 0.2s;
}
.jbmc-swiper .swiper-pagination-bullet-active {
  background: #C9962A !important;
  width: 22px !important;
  border-radius: 4px !important;
}

/* ── Match card ── */
.jbmc-card {
  background: linear-gradient(160deg, #3D0A0A 0%, #5A1010 100%);
  border: 1px solid rgba(201,150,42,0.22);
  border-radius: 16px;
  padding: clamp(18px, 2.5vw, 24px) clamp(14px, 2vw, 18px);
  display: flex; flex-direction: column; align-items: center; text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
  position: relative; overflow: hidden;
}
.jbmc-card::after {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, transparent, #C9962A, transparent);
}
.jbmc-card:hover {
  border-color: rgba(201,150,42,0.5);
  transform: translateY(-3px);
  box-shadow: 0 12px 36px rgba(0,0,0,0.4);
}

/* avatar ring */
.jbmc-avatar-wrap {
  position: relative;
  width: clamp(84px, 10vw, 104px);
  height: clamp(84px, 10vw, 104px);
  margin-bottom: 14px;
}
.jbmc-avatar {
  width: 100%; height: 100%;
  object-fit: cover; border-radius: 50%;
  border: 3px solid #C9962A;
  box-shadow: 0 0 0 4px rgba(201,150,42,0.15), 0 4px 16px rgba(0,0,0,0.3);
}
.jbmc-avatar-om {
  position: absolute; bottom: 0; right: 0;
  width: 24px; height: 24px; border-radius: 50%;
  background: #C9962A;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; color: #2C1A0E; font-family: serif;
  border: 2px solid #3D0A0A;
}

/* card text */
.jbmc-name {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px, 1.6vw, 16px);
  font-weight: 700; color: #FDF6EC;
  margin-bottom: 4px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  max-width: 100%;
}
.jbmc-details {
  font-size: clamp(11px, 1.15vw, 12.5px);
  color: rgba(253,246,236,0.62);
  line-height: 1.55; margin-bottom: 14px;
}

/* card button */
.jbmc-card-btn {
  padding: 7px 20px;
  background: transparent;
  border: 1.5px solid rgba(201,150,42,0.55);
  border-radius: 20px;
  color: #E8C46A;
  font-size: clamp(11px, 1.1vw, 12.5px);
  font-weight: 600;
  cursor: pointer; font-family: 'Inter', sans-serif;
  transition: background 0.18s, border-color 0.18s;
}
.jbmc-card:hover .jbmc-card-btn {
  background: rgba(201,150,42,0.15);
  border-color: #C9962A;
}

/* ── Empty state ── */
.jbmc-empty {
  position: relative; z-index: 1;
  text-align: center;
  padding: clamp(28px, 4vw, 48px) 16px;
}
.jbmc-empty-om {
  font-size: 44px; color: #C9962A; opacity: 0.25;
  font-family: serif; margin-bottom: 12px;
}
.jbmc-empty-txt {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px, 1.6vw, 17px);
  color: rgba(253,246,236,0.5);
}

/* ── Responsive ── */
@media (max-width: 560px) {
  .jbmc-header { flex-direction: column; align-items: flex-start; }
  .jbmc-viewall { align-self: flex-start; }
}
`;

/* ─── Skeleton card ───────────────────────────────────────────────────────── */
const SkeletonCard = () => (
  <div className="jbmc-skel-card">
    <div className="jbmc-skel-avatar" />
    <div className="jbmc-skel-line" style={{ width: "70%" }} />
    <div className="jbmc-skel-line" style={{ width: "50%" }} />
    <div className="jbmc-skel-line" style={{ width: "40%", height: 8 }} />
  </div>
);

/* ─── Component ───────────────────────────────────────────────────────────── */
const MatchesCarousel = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const navigate = useNavigate();

  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

  /* inject CSS */
  useEffect(() => {
    const id = "jbmc-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/api/matches/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        setMatches(res.data);

        const profileRes = await axios.get("/api/matrimony-profile/update/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        const percent = profileRes.data.profile_completion_percentage;
        setCompletionPercentage(percent);
        if (percent < 90 && !localStorage.getItem("profileModalShown")) {
          setShowCompletionModal(true);
          localStorage.setItem("profileModalShown", "true");
        }
      } catch {
        toast.error("Failed to load matches");
      } finally {
        setLoading(false);
      }
    };
    fetchMatches();
  }, []);

  const slidesBreakpoints = (count) =>
    count === 1
      ? {}
      : {
          0: { slidesPerView: 1 },
          640: { slidesPerView: Math.min(count, 1) },
          768: { slidesPerView: Math.min(count, 2) },
          1024: { slidesPerView: Math.min(count, 3) },
        };

  return (
    <div className="jbmc">
      <div className="jbmc-dust" aria-hidden="true" />

      <ProfileCompletionModal
        isOpen={showCompletionModal}
        onClose={() => setShowCompletionModal(false)}
        percentage={completionPercentage}
      />

      {/* ── Header ── */}
      <div className="jbmc-header">
        <div>
          <h2 className="jbmc-title">
            Sacred <em>Matches</em>{" "}
            <span className="jbmc-count">({matches.length})</span>
          </h2>
          <p className="jbmc-subtitle">
            Souls aligned with your values, family, and Dharma
          </p>
        </div>
        <button
          className="jbmc-viewall"
          onClick={() => navigate("/matches-all--php-html-raj-put")}
        >
          View All →
        </button>
      </div>

      {/* ── Loading skeletons ── */}
      {loading ? (
        <div className="jbmc-skel">
          {[...Array(3)].map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      ) : matches.length > 0 ? (
        /* ── Swiper carousel ── */
        <Swiper
          className="jbmc-swiper"
          spaceBetween={16}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          modules={[Pagination, Autoplay]}
          slidesPerView={matches.length === 1 ? 1 : undefined}
          breakpoints={slidesBreakpoints(matches.length)}
        >
          {matches.map((match) => (
            <SwiperSlide key={match.id}>
              <div
                className="jbmc-card"
                onClick={() => navigate(`/profile/${match.user.id}`)}
                role="button"
                tabIndex={0}
                aria-label={`View profile of ${match.user.first_name}`}
                onKeyDown={(e) =>
                  e.key === "Enter" && navigate(`/profile/${match.user.id}`)
                }
              >
                {/* Avatar */}
                <div className="jbmc-avatar-wrap">
                  <img
                    src={
                      match.photo || require("../../assets/default_image.webp")
                    }
                    alt={match.user.first_name}
                    className="jbmc-avatar"
                  />
                  <div className="jbmc-avatar-om" aria-hidden="true">
                    ꣽ
                  </div>
                </div>

                {/* Name */}
                <p className="jbmc-name">
                  {match.user.first_name} {match.user.last_name}
                </p>

                {/* Details */}
                <p className="jbmc-details">
                  {calculateAge(match.dob)} Yrs
                  {match.height_feet
                    ? ` • ${match.height_feet}'${match.height_inches}"`
                    : ""}
                  {match.work_location_city
                    ? ` • ${match.work_location_city}`
                    : ""}
                </p>

                <button
                  className="jbmc-card-btn"
                  tabIndex={-1}
                  aria-hidden="true"
                >
                  🪷 View Profile
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        /* ── Empty state ── */
        <div className="jbmc-empty">
          <div className="jbmc-empty-om" aria-hidden="true">
            ꣽ
          </div>
          <p className="jbmc-empty-txt">
            No sacred matches found yet — complete your profile to begin.
          </p>
        </div>
      )}
    </div>
  );
};

export default MatchesCarousel;
